import React, { useEffect, useRef } from "react";
import Pusher from "pusher-js";
import { useState } from "react";
import { ChatHeader } from "../ChatHeader/ChatHeader";
import ChatLeft from "../ChatLeft/ChatLeft";
import ChatList from "../ChatList/ChatList";
import ChatRight from "../ChatRight/ChatRight";
import ChatWriter from "../ChatWriter/ChatWriter";
import axios from "axios";
import {
  useGetChatBox,
  useGetChatData,
  useGetCompanyUsers,
  useGetSupplierList,
} from "../../hooks/useCrm";
import { useRecoilState, useRecoilValue } from "recoil";
import { chatIdAtom } from "../../shared/chatId";
import { chatDataAtom, newMessage } from "../../shared/chatContent";
import { useQueryClient } from "react-query";
import { OnlineChatSupplierStyle } from "./OnlineChatSupplierStyle";

const OnlineChatSupplier = () => {
  const [chatInfo, setChatInfo] = useState({
    text: "",
    username: "",
    chats: [],
    IdStartChat: "",
  });

  const [recoilValue, setCollectionChat] = useRecoilState(chatDataAtom);
  const [newMessState, setNewMessState] = useRecoilState(newMessage);

  const [idUser, setIdUser] = useState();

  const { mutateAsync: chatBoxData, data: BoxChats } = useGetChatBox();

  const handleGetChatBox = async (id, iduser) => {
    await chatBoxData({ startChatId: id }).then((d) => {
      setCollectionChat(d?.data?.Chats);
    });
    setIdUser(iduser);
    bottomref.current?.scrollIntoView({ behavior: "smooth" });
  };

  const queryClient = useQueryClient();

  const beforeMessages = useRecoilValue(chatDataAtom);

  const { data: chatData, isLoading } = useGetChatData();

  const { data: Supplier, isLoading: SupplierListLoading } =
    useGetCompanyUsers();

  const chatList = chatData?.data?.Chats;

  const userdata = JSON.parse(localStorage.getItem("profile"));

  const id = userdata?.users[0]?.IdUser;

  const idStartChat = useRecoilValue(chatIdAtom);

  const bottomref = useRef(null);

  const handleAppendMessage = (newMessage) => {
    setNewMessState(newMessage?.message);
    bottomref.current?.scrollIntoView({ behavior: "smooth" });
    queryClient.invalidateQueries("chat-data");
  };
  const Suppliers = Supplier?.data?.ManagersAndColleagues;
  // const Suppliers =
  const SuppliersOption = Suppliers?.map((sup) => {
    return {
      value: sup.IdUser,
      label:
        (sup.FirstName ? sup.FirstName : "") +
        " " +
        (sup.LastName ? sup.LastName : ""),
    };
  });

  useEffect(() => {
    setCollectionChat([...recoilValue, newMessState]);
  }, [newMessState]);

  useEffect(() => {
    setChatInfo({ ...chatInfo, username: id });
    const pusher = new Pusher("d661bd579a1f9fcb556f", {
      cluster: "ap2",
      encrypted: true,
    });
    let channel = pusher.subscribe("chat");

    channel.bind("message", handleAppendMessage);
  }, []);

  const submit = async () => {
    const payload = {
      IdUser: chatInfo.username,
      message: chatInfo.text,
      IdStartChat: idStartChat,
    };

    await axios
      .post("https://crmapibama.metanext.biz/api/testSendChat", payload)
      .then(() => setChatInfo({ ...chatInfo, text: "" }));
  };

  const chat = beforeMessages?.map((chat, index) => {
    if (idUser === undefined && chat.IdWriter === undefined) {
      return false;
    }
    if (idUser === chat?.IdWriter && chat) {
      return <ChatRight APIChat={chat} key={index} />;
    }
    if (
      idUser !== chat?.IdWriter &&
      chat &&
      idUser === undefined &&
      chat.IdWriter === undefined
    ) {
      return <ChatLeft APIChat={chat} key={index} />;
    }
  });

  return (
    <OnlineChatSupplierStyle>
      <div className="row">
        <div className="chat-list col-xl-4 col-lg-4 ">
          <ChatList
            data={chatList}
            isLoading={isLoading}
            handleGetChatBox={handleGetChatBox}
          />
        </div>
        <div className="col-xl-8 col-lg-8">
          <div className="chat-box">
            <ChatHeader
              data={"یک شخص را انتخاب کنید"}
              refer={SuppliersOption}
              idStartChat={idStartChat}
              supplier
            />
            <div className="chat-holder">
              {chat}
              <div ref={bottomref}></div>
            </div>
            <ChatWriter
              setChatInfo={setChatInfo}
              chatInfo={chatInfo}
              submit={submit}
            />
          </div>
        </div>
      </div>
    </OnlineChatSupplierStyle>
  );
};

export default OnlineChatSupplier;
